import { useCapabilities } from '@/features/authentication/hooks/useCapabilities';
import { NAVIGATION_GROUPS, type NavigationGroup } from '@/shared/config/navigation';

/**
 * Visible navigation groups for the current caller. All protected entries use V3 broad hints.
 */
export function useNavigationGroups(): NavigationGroup[] {
  const { hasCapability } = useCapabilities();
  return NAVIGATION_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => item.visibleWhen?.(hasCapability) ?? true),
  })).filter((group) => group.items.length > 0);
}
